import { GLTFLoader, DRACOLoader, MeshoptDecoder } from 'three-stdlib';
import { useLoader } from '@react-three/fiber'; // @ts-ignore

var dracoLoader = null;

function extensions(useDraco, useMeshopt, extendLoader) {
  return function (loader) {
    if (extendLoader) {
      extendLoader(loader);
    }

    if (useDraco) {
      if (!dracoLoader) {
        dracoLoader = new DRACOLoader();
      }

      dracoLoader.setDecoderPath(typeof useDraco === 'string' ? useDraco : 'https://www.gstatic.com/draco/versioned/decoders/1.4.3/');
      loader.setDRACOLoader(dracoLoader);
    }

    if (useMeshopt) {
      loader.setMeshoptDecoder(typeof MeshoptDecoder === 'function' ? MeshoptDecoder() : MeshoptDecoder);
    }
  };
}

function useGLTF(path) {
  var useDraco = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var useMeshOpt = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var extendLoader = arguments.length > 3 ? arguments[3] : undefined;
  var gltf = useLoader(GLTFLoader, path, extensions(useDraco, useMeshOpt, extendLoader));
  return gltf;
}

useGLTF.preload = function (path) {
  var useDraco = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var useMeshOpt = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var extendLoader = arguments.length > 3 ? arguments[3] : undefined;
  return useLoader.preload(GLTFLoader, path, extensions(useDraco, useMeshOpt, extendLoader));
}; // @ts-expect-error new in r3f 7.0.5


useGLTF.clear = function (input) {
  return useLoader.clear(GLTFLoader, input);
};

export { useGLTF };